import {
    BASE_URL
} from '../../config';

import {
    END_INVALID_ORDER_EDIT,
    FETCHING_INVALID_ORDERS,
    INVALID_ORDERS_COUNT_UPDATED,
    INVALID_ORDERS_UPDATED,
    START_INVALID_ORDER_EDIT
} from './order.actionsTypes';
import axios from 'axios';

export const fetchInvalidOrders = () => {
    return async (dispatch) => {
        dispatch({type: FETCHING_INVALID_ORDERS});
        const response = await axios.get(`${BASE_URL}order/invalid`)
        dispatch({
            type: INVALID_ORDERS_UPDATED,
            payload: response.data,
        });

    };
};

export const deleteInvalidOrder = (ids) => {
    return async (dispatch) => {
        if (typeof ids === "string") {
            ids = [ids];
        }
        for(const id of ids) {
            await axios.delete(`${BASE_URL}order/invalid/${id}`);
        }
        dispatch(fetchInvalidOrders())
    };
};

export const startErrorEdit = id => {
    console.log('Starting edit of', id)
    return {
        type: START_INVALID_ORDER_EDIT,
        payload: id
    }
}
export const endErrorEdit = () => {
    return {
        type: END_INVALID_ORDER_EDIT
    }
}

export const reQueueInvalidOrder = (id, body) => {
    return async (dispatch) => {
        await axios.post(`${BASE_URL}order/invalid/${id}`, body);
        await dispatch(fetchInvalidOrders())
        dispatch(endErrorEdit())
    };
};


export const getInvalidOrdersCount = () => {
    return (dispatch) => {
        const response = axios.get(`${BASE_URL}order/invalidOrdersCount`);
        dispatch({
            type: INVALID_ORDERS_COUNT_UPDATED,
            payload: +response.data
        });
    };
};




